import React from 'react';

export default function Footer() {
  const date = new Date().getFullYear();
  return (
    <footer style={{ textAlign: 'center' }}>
      <p>&copy; {date} Eric Blohm</p>
    </footer>
  );
}
